import * as React from 'react';

import Button from '@components/Button';
import { PatchedLink } from '@utils/patched-link';

import { BannerLabel, CampainBannerContainer } from './styled';

export interface ICampainBanner {
  title: string;
  href?: string;
}

const CampainBanner = ({ title = '', href }: ICampainBanner) => {
  return (
    <CampainBannerContainer>
      <BannerLabel>{title}</BannerLabel>
      {href ? (
        <PatchedLink href={href} prefetch={false}>
          <Button outline size='xlarge'>
            Tümünü Gör
          </Button>
        </PatchedLink>
      ) : null}
    </CampainBannerContainer>
  );
};

export default CampainBanner;
